import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { WebsiteLockProvider } from './contexts/WebsiteLockContext';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WebsiteLockProvider>
      <App />
    </WebsiteLockProvider>
  </StrictMode>
);
